import { EnvironmentTargetInterface } from '@environments/assets/environment-target.interface';

export const notificationApiTargets: EnvironmentTargetInterface = {
  build: {
    baseUrl: 'https://api.meldinger.fagforbundet.build',
  },
  production: {
    baseUrl: 'https://api.meldinger.fagforbundet.no',
  },
  staging: {
    baseUrl: 'https://api.meldinger.fagforbundet.dev',
  },
};
